(() => {
  angular.module('app').controller('common.views.claims.process.index', ClaimProcessPageController);

  ClaimProcessPageController.$inject = ['$stateParams'];

  function ClaimProcessPageController($stateParams) {
    const vm = this;

    vm.claimNumber = $stateParams.claimNumber;
    vm.receiptDate = null;
    vm.isCorporate = App.isCorporate();

    // HM-11152 — the ACE Results Box hands the parsed §11 analysis up here; the claim-detail
    // widget receives it through a one-way binding and applies its own auto-fill. Never set for
    // the not-submitted, pending, failed or timed-out states.
    vm.aceAnalysis = null;
    vm.onAceAnalysisReady = onAceAnalysisReady;

    init();

    function init() {}

    function onAceAnalysisReady(analysis) {
      vm.aceAnalysis = analysis;
    }
  }
})();
